export default "__VITE_ASSET__defd3238__"